import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { redirectToCARTPage, redirectToCheckoutPage } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ORDER_STATUS } from 'common/constants/SharedConstants';

export const createCheckoutButton = props => {
  const isPaymentFailed = props?.orderAccepted?.status?.toUpperCase?.() === ORDER_STATUS.PAYMENT_FAILED;
  return (
    props?.orderAccepted?.status && (
      <ButtonComp
        data-testid='Back-Cart-Button'
        className='button whiteButton blackBorder back-To-Cart'
        onClick={() => {
          isPaymentFailed ? redirectToCheckoutPage(props, true) : redirectToCARTPage(props);
        }}
      >
        {translateWithI18Next(
          isPaymentFailed ? TRANSLATE_MAPPING_KEY?.RETUEN_TO_CHECKOUT : TRANSLATE_MAPPING_KEY?.RETUEN_TO_CART,
        )}
      </ButtonComp>
    )
  );
};

export const statusTextChange = () => {
  return (
    <>
      <div className='notRight'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.PAYMENT_FAILED_TITLE)}</div>
      <div className='Reason'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.PAYMENT_FAILED_SUBTITLE)}</div>
    </>
  );
};

const PaymentFailedView = props => {
  return (
    <div className='PaymentFailedScreen'>
      <div className='paymentFailed'>
        <div className='FailedDisplay'>
          <div className='Failimage'>
            <img src={IMAGE_PATH?.Issue} alt='issue img' />
          </div>
          {statusTextChange()}
          <div className='backToCart'>{createCheckoutButton(props)}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaymentFailedView);
